<template>
  <div>
    <CommonPopup ref="refCommonPopup">
      <div class="user-auth-popup">
        <div class="user-auth-popup-content">
          <div class="user-auth-popup-title">用户授权提示</div>
          <div class="user-auth-popup-info">
            请您仔细阅读<span
              class="text-link"
              @click="openServiceProtocol"
            >《用户授权协议》</span>，同意授权后，再购买充电服务。
          </div>
          <div class="user-auth-popup-checkbox">
            <van-radio-group v-model="radio">
              <van-radio
                name="1"
                shape="square"
              >我已阅读并同意授权</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="user-auth-popup-btns">
          <div
            class="user-auth-popup-btn btn-default"
            @click="handleCancel"
          >
            返回
          </div>
          <div
            class="user-auth-popup-btn btn-primary"
            @click="handleConfirm"
          >
            确定，下一步
          </div>
        </div>
      </div>
    </CommonPopup>

    <ServiceProtocolPopup ref="refServiceProtocolPopup" />
  </div>
</template>

<script>
import CommonPopup from './CommonPopup';
import ServiceProtocolPopup from './ServiceProtocolPopup';

export default {
  name: 'UserAuthPopup',
  components: {
    CommonPopup,
    ServiceProtocolPopup
  },
  data() {
    return {
      radio: '0'
    };
  },
  methods: {
    openPopup() {
      this.$refs.refCommonPopup.openPopup();
    },
    closePopup() {
      this.$refs.refCommonPopup.closePopup();
    },
    handleConfirm() {
      if (!(this.radio == '1')) {
        this.$toast('请勾选同意授权，再点击确定');
        return;
      }
      this.$emit('confirm');
    },
    handleCancel() {
      this.$emit('cancel');
      wx.miniProgram.navigateBack();
    },
    openServiceProtocol() {
      this.$refs.refServiceProtocolPopup.openPopup();
    }
  }
};
</script>

<style lang="scss" scoped>
.user-auth-popup {
  background: #ffffff;
  border-radius: 20px;
  height: 505px;
  width: 600px;
  padding: 48px 32px 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  .user-auth-popup-content {
    .user-auth-popup-title {
      font-size: 40px;
      color: #383838;
      text-align: center;
      font-weight: bold;
      margin-bottom: 48px;
      line-height: 56px;
    }
    .user-auth-popup-info {
      font-size: 32px;
      color: #383838;
      font-weight: 400;
      margin-bottom: 48px;
      line-height: 45px;
    }
    .user-auth-popup-checkbox {
      font-size: 32px;
      color: #787878;
      letter-spacing: 0;
      font-weight: 400;
      margin-bottom: 48px;
      line-height: 45px;
    }
  }
  .user-auth-popup-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .user-auth-popup-btn {
      width: 252px;
      height: 90px;
      border-radius: 20px;
      font-size: 32px;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;

      &.btn-default {
        border: 1px solid rgba(200, 200, 200, 1);
        background: #ffffff;
        color: #383838;
      }
      &.btn-primary {
        background: #fe7256;
        color: #ffffff;
      }
    }
  }
  .text-link {
    font-size: 32px;
    color: #3399ff;
    line-height: 45px;
    font-weight: 400;
    cursor: pointer;
  }
}
</style>
